const toastsReducer = (state=[], action)=>{
  switch (action.type) {
    case 'ADD_TOAST':
      if(action.id && state.find(t=>t.id===action.id)){
        return state;
      }
      return [
        ...state,
        {
          id:action.id || (new Date()).getTime(),
          message:action.message,
          important:action.important,
          duration:action.duration,
          onClick: action.onClick
        }
      ]
    case 'REMOVE_TOAST':
      return state.filter(t => t.id !== action.payload)
   default:
     return state
 }
}
export default toastsReducer;



// WEBPACK FOOTER //
// ./src/utils/reducers/toasts.js